<template>
    <div>
        <div>
            <simulator v-if="session" :session="session"></simulator>
            <welcome v-if="!session"></welcome>
        </div>
        <editorTabs ref="tabs"></editorTabs>
    </div> 
</template>

<script>
    import editorTabs from 'components/workbench/EditorTabs'
    import simulator from 'components/workbench/simulator/Simulator'
    import Session from 'runtime/session.js';
    import splitter from 'components/utils/Splitter';
    import welcome from 'components/workbench/Welcome'
    import proxy from 'components/console/consoleProxy.js';

    export default {
        name: "workbench",
        data() {
            return {
                session: null,
                splitterOptions: {
                    direction: "vertical",
                    sizes: [50, 50]
                }
            }
        },
        methods: {
            setSession(session) {
                if (this.session) {
                    // First cleanup old session
                    this.session.destroy();
                }
                this.session = session;
                this.$refs.tabs.setSession(session);
            }
        },
        mounted() {
            if (!this.session) {
                proxy.info("System", "Welcome to Parapple!");
                proxy.debug("System", "This is the main console where you'll see system logs as well as logs from all agents.");
            }
        },
        components: {
            editorTabs,
            simulator,
            splitter,
            welcome
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Workbench.vue?7748e99f